import React from "react";
import { Box, TablePagination } from "@mui/material";

export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [50, 100, 200];

/**
 * Shared MUI table pagination for Penner Management lists.
 * `page` is 0-based (MUI convention).
 */
const PennerTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  if (!count) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={(_, nextPage) => onPageChange(nextPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          onRowsPerPageChange(parseInt(event.target.value, 10));
        }}
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        labelRowsPerPage="Rows"
        showFirstButton
        showLastButton
      />
    </Box>
  );
};

export default PennerTablePagination;
